<div class="stub-wrapper">
  <ng-container *ngIf="stubData.stubIcon.length > 0; else svgIcon">
    <mat-icon>{{ stubData.stubIcon }}</mat-icon>
  </ng-container>

  <ng-template #svgIcon>
    <mat-icon *ngIf="stubData.svgIcon.length > 0" [svgIcon]="stubData.svgIcon"></mat-icon>
  </ng-template>

  <h1>{{ stubData.stubText | translate }}</h1>

  <div class="in-case-of-new-request" *ngIf="isNeedRefreshData()">
    <div class="system-reports" *ngIf="isNeedRefreshDataForSystemReports">
      <p>{{ 'all-reports.data-processing.newRequest' | translate }}</p>
      <mee-date-picker
        [isWithoutLabel]="true"
        [dateReturnFormat]="'YYYY-MM-DD'"
        (onChooseNewDate)="onChangeSelectedDate($event)"></mee-date-picker>
    </div>
  </div>
</div>
